import { COVERAGES_TYPES } from "./coveragesTypes";
import { extractMessage } from "../../../helpers/extractError";

const {
  SET_COVERAGES,
  ADD_COVERAGE,
  SET_NEW_COVERAGE,
  EDIT_COVERAGE_MODE,
  SET_EDITED_COVERAGE,
  DELETE_COVERAGE_MODE,
  DELETE_COVERAGE,
  CLEAR_COVERAGES,
  SET_SNACKBAR_SEARCH,
  SET_SELECTED_COVERAGE,
  SET_DELETED_COVERAGE,
  SET_BRANDS,
  HANDLE_COVERAGES_INPUTS,
} = COVERAGES_TYPES;

const initialState = {
  coverages: [],
  coverageSelected: null,
  zoneTypeList: [{ value: 'ZONE', label: 'ZONA SEGURA' }, { value: 'RISK_ZONE', label: 'ZONA DE RIESGO' }],
  productTypeList: [{ value: 'PORTATIL', label: 'PORTATIL' }, { value: 'ESTACION', label: 'ESTACIONARIO' }],
  brandList: [],
  station: null,

  //edit
  addMode: false,
  deleteMode: false,
  editCoverage: null,

  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  }
};

export const coveragesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_COVERAGES_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };

    case SET_COVERAGES:
      return {
        ...state,
        coverages: payload.coverages
      };

    case SET_BRANDS:
      return {
        ...state,
        brandList: payload
      };

    case EDIT_COVERAGE_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false,
      };

    case DELETE_COVERAGE_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true,
      };

    case SET_DELETED_COVERAGE:
      return {
        ...state,
        coverages: state.coverages.filter(coverage => coverage.id !== payload)
      };

    case SET_SELECTED_COVERAGE:
      return {
        ...state,
        coverageSelected: payload
      };

    case ADD_COVERAGE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      };

    case SET_NEW_COVERAGE: {
      const newCoverages = [...payload, ...state.coverages];

      return {
        ...state,
        coverages: newCoverages
      };
    }

    case SET_EDITED_COVERAGE: {
      const newCoverages = [...state.coverages];
      const indexToEdit = newCoverages.findIndex(
        coverage => coverage.id === payload.id
      );

      if (indexToEdit !== -1) {
        newCoverages[indexToEdit] = payload;
      }

      return {
        ...state,
        coverages: newCoverages
      };
    }

    case DELETE_COVERAGE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      };

    case CLEAR_COVERAGES:
      return {
        ...state,
        ...initialState
      };

    // snackbar
    case SET_SNACKBAR_SEARCH:
      return {
        ...state,
        message: extractMessage(payload?.message) || 'Error en el servicio, contacte a Soporte para mas información',
        color: payload.color,
        isOpen: true,
        position: payload?.position || 'tr'
      };

    default:
      return state;
  }
};
